<template>
  <div
    class="c-serviceSearchHeaderFacetSelectedItems"
    v-if="selectedItems.length"
  >
    <ServiceSearchHeaderFacetSelectedItem
      v-for="(item, index) in selectedItems"
      :key="`item${index}`"
      :item-value="item"
      class="c-serviceSearchHeaderFacetSelectedItems_selectedItem"
      @clear-facet="clearFacet($event)"
    >
      <span class="c-facetLabel">{{ item.name }}</span>
    </ServiceSearchHeaderFacetSelectedItem>
  </div>
</template>
<script>
import ServiceSearchHeaderFacetSelectedItem from './ServiceSearchHeaderFacetSelectedItem'

export default {
  name: 'ServiceSearchHeaderFacetSelectedItems',
  components: {
    ServiceSearchHeaderFacetSelectedItem
  },
  props: {
    conditionOptions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    selectedItems() {
      const options = []
      this.conditionOptions.forEach(o => {
        if (o.option.value) {
          o.master.valuesList.some(l => {
            if (l.value === o.option.value) {
              options.push({
                key: o.master.key,
                id: l.id,
                name: l.name,
                value: l.value,
                valuesList: [],
                allowsMultipleSelect: o.master.type,
                relatedCategoryId: o.option.relatedCategoryId
              })
            }
          })
        } else if (o.option.valuesList?.length) {
          o.option.valuesList.forEach(v => {
            o.master.valuesList.some(l => {
              if (l.value === v) {
                options.push({
                  key: o.master.key,
                  id: l.id,
                  name: l.name,
                  value: l.value,
                  valuesList: o.option.valuesList,
                  allowsMultipleSelect: o.master.type,
                  relatedCategoryId: o.option.relatedCategoryId
                })
              }
            })
          })
        }
      })
      return options
    }
  },
  methods: {
    clearFacet(e) {
      if (e.allowsMultipleSelect === 'checkbox') {
        const newValuesList = e.valuesList.filter(v => v !== e.value)
        this.$emit('clear-facet', {
          key: e.key,
          value: newValuesList,
          categoryId: e.relatedCategoryId
        })
      } else {
        this.$emit('clear-facet', { key: e.key, value: [], categoryId: e.relatedCategoryId })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$labelPadding: 36px;

.c-serviceSearchHeaderFacetSelectedItems {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  &_selectedItem {
    margin-right: 16px;
    :last-child {
      margin-right: 0;
    }
  }
}
.c-facetLabel {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: breakpoint(Search, XL)) {
  .c-facetLabel {
    max-width: calc(964px - #{$labelPadding});
  }
}
@media (min-width: breakpoint(Search, M) + 1) and (max-width: breakpoint(Search, XL) - 1) {
  .c-facetLabel {
    max-width: calc(712px - #{$labelPadding});
  }
}

@media (max-width: breakpoint(Search, M)) {
  .c-serviceSearchHeaderFacetSelectedItems {
    padding: 0 12px;
  }
  .c-facetLabel {
    max-width: calc(100vw - #{$labelPadding});
  }
}
</style>
